<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
    <g clip-path="url(#clip0_2130_5292)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.85303 11.3794L1.85303 7.80371L5.86304 7.80371L5.86304
      11.3794L1.85303 11.3794ZM7.36304 11.3794L7.36304 7.80371L11.3428
      7.80371L11.3428 11.3794L7.36304 11.3794ZM12.8428 11.3794L16.853
      11.3794L16.853 7.80371L12.8428 7.80371L12.8428 11.3794ZM15.353
      6.30371L16.853 6.30371C17.6815 6.30371 18.353 6.97528 18.353
      7.80371L18.353 11.3794C18.353 12.2078 17.6815 12.8794 16.853
      12.8794L15.353 12.8794L15.353 14.3111C15.353 15.0153 14.7603 15.5916
      14.0358 15.5916L4.67027 15.5916C3.94579 15.5916 3.35303 15.0153 3.35303
      14.3111L3.35303 12.8794L1.85303 12.8794C1.0246 12.8794 0.353027 12.2078
      0.353027 11.3794L0.353027 7.80371C0.353027 6.97528 1.0246 6.30371
      1.85303 6.30371L3.35303 6.30371L3.35303 4.87201C3.35303 4.16349 3.94139
      3.59155 4.67027 3.59155L14.0358 3.59155C14.7604 3.59155 15.353 4.16117
      15.353 4.87201L15.353 6.30371ZM14.0315 6.30371L14.0315 4.87086L11.887
      4.87086L11.887 6.30371L12.8428 6.30371L14.0315 6.30371ZM10.387
      6.30371L10.387 4.87086L8.26685 4.87086L8.26685 6.30371L10.387
      6.30371ZM6.76685 6.30371L6.76685 4.87086L4.67027 4.87086L4.67027
      6.30371L6.76685 6.30371ZM4.67027 12.8794L4.67027 14.3121L6.76685
      14.3121L6.76685 12.8794L4.67027 12.8794ZM8.26685 12.8794L8.26685
      14.3121L10.387 14.3121L10.387 12.8794L8.26685 12.8794ZM11.887
      12.8794L11.887 14.3121L14.0315 14.3121L14.0315 12.8794L11.887 12.8794Z"
        fill="#A2B1C6"
      />
    </g>
    <defs>
      <clipPath id="clip0_2130_5292">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.353027 18.5916) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'RowIcon'
}
</script>
